import BadgeIcon from "@mui/icons-material/Badge";
import { Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDialogBetter } from "../../../hooks/useDialogBetter";
import { PersonDetailsDialog } from "./PersonDetailsDialog";

export const PersonDetailsButton = (props) => {
    const { personId, disabled = false, showLabel = true, variant = "text" } = props;
    const { t } = useTranslation();
    const { openDialog } = useDialogBetter();

    const handleOpenPersonDetailsDialog = () => {
        openDialog({
            Component: PersonDetailsDialog,
            componentProps: {
                personId: personId,
            },
        });
    };

    return (
        <Button
            onClick={handleOpenPersonDetailsDialog}
            disabled={disabled}
            variant={variant}
            fullWidth
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: 0.5,
                py: 1.5,
                minHeight: showLabel ? 80 : "auto",
            }}
        >
            <BadgeIcon sx={{ fontSize: showLabel ? 32 : 24 }} />
            {showLabel && (
                <Typography variant="caption" sx={{ textTransform: "none", lineHeight: 1.2 }}>
                    {t("customers.PersonDetailsDialog.title")}
                </Typography>
            )}
        </Button>
    );
};
